import { render } from "./lock-screen.vue?vue&type=template&id=b962987a"
import script from "./lock-screen.vue?vue&type=script&lang=js"
export * from "./lock-screen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__